import React, { Component } from 'react';
import '../styles/Contacto.css';
import ScrollTop from './ScrollTop'
import contactoImage from '../images/contacto/mapa.png'
import mailIcon from '../icons/contacto/mail.svg'
import headsetIcon from '../icons/contacto/headset.svg'
import Analytics from './Analytics'

class Contacto extends Component {
    render(){
        return (
            <div className="Contacto">
                <ScrollTop />
                <Analytics />
                <div class="contacto-container">
                    <img src={contactoImage} class="contact-img" />
                    <div class="title-contacto-container">
                        <h2>Contáctenos</h2>
                        <p>Asesoramiento contínuo</p>
                    </div>
                <div class="square-container">
                    <div class="square-contacto">
                        <h4>COMUNIQUESE CON NOSOTROS</h4>
                        <p>Envíenos un email con su consulta y le daremos una respuesta inmediata. </p>
                        <div class="mail-contacto">
                            <img src={mailIcon} /> 
                            <span>atencionalcliente@<span class="color-contacto">globalfarm</span>.com.ar</span>
                        </div>
                        <hr class="line-separator" />
                        <p>O bien llámenos para acordar una visita a nuestras oficinas.</p>
                        <div class="mail-contacto">
                            <img src={headsetIcon} />
                            <span> 0800-362-<span class="color-contacto">GLOBAL</span> (4562)</span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default Contacto;


// WEBPACK FOOTER //
// ./src/components/Contacto.js